module.exports = __webpack_public_path__ + "static/kart-game-race-stadion-39693329dc413d325c4ab1505471165a.jpg";